import { Component, EventEmitter, Output, Renderer2, Input, AfterViewInit, OnChanges, OnDestroy } from '@angular/core';
import { XmlRuleElement } from '../../code/xml-rules-check/xmlRuleElement.class';
import { XmlCursorPos } from '../../code/cursor/xmlCursorPos.class';
import { XmlEditRuleCheckElements } from '../../code/xml-rules-check/xmlEditRuleCheckElements.class';
import { AngularXmlEditorService } from '../../angular-xml-editor.service';
import { Subscription } from 'rxjs';
import { XmlEditorContext } from '../../code/xmlEditorContext.class';
import { XmlEditorConfig } from '../../code/xmlEditorConfig';
import { Xml2html } from '../../code/xml-html-converter/xml2html.class';

@Component({
  selector: 'axed-toolbar',
  templateUrl: './xml-editor-toolbar.component.html',
  styleUrls: ['./xml-editor-toolbar.component.scss']
})
export class XmlEditorToolbarComponent implements AfterViewInit, OnChanges, OnDestroy {
  private editorContext: XmlEditorContext;

  @Input('config')
  get config(): XmlEditorConfig {
    if (this.editorContext !== undefined && this.editorContext.config !== undefined) {
      return this.editorContext && this.editorContext.config;
    }
    return undefined;
  }

  @Input('editorContextId')
  set editorContextId(value: string) {
    if (!value) {
      return;
    }
    this.editorContext = this.editorService.getEditorContext(value);
    this.actualCursorPosChangedSubscription = this.editorContext.actualCursorChanged.subscribe(pos => {
      this.elementGroups = this.GetElementGroupsForCursorPos(pos.StartPos);
    });
  }

  elementGroups: ToolbarElementGroup[] = [];

  actualCursorPosChangedSubscription: Subscription;

  /** inserts an element at the actual cursor pos */
  insertElement(element: XmlRuleElement) {
    const html = new Xml2html(this.editorContext.config.rules).createNewElementHtml(element);
    this.editorContext.domInsertHtml(html);
  }

  constructor(private editorService: AngularXmlEditorService) {}

  ngAfterViewInit(): void {}
  ngOnChanges(): void {}

  ngOnDestroy(): void {
    this.actualCursorPosChangedSubscription.unsubscribe();
  }

  GetElementGroupsForCursorPos(pos: XmlCursorPos): ToolbarElementGroup[] {
    const allowedElements = new XmlEditRuleCheckElements(this.editorContext.config.xmlSchema.xsdNodes).ElementsAllowedAtThisCursorPos(pos);

    return this.GetAllElementGroups()
      .map(g => {
        return {
          title: g.title,
          elements: g.elements.filter(e => allowedElements.includes(e.tagName))
        } as ToolbarElementGroup;
      })
      .filter(g => g.elements.length > 0);
  }

  GetAllElementGroups(): ToolbarElementGroup[] {
    const unusedElements = XmlRuleElement.Sorted(
      Array.from(this.editorContext.config.rules.ruleElements.values()).filter(elem =>
        this.editorContext.config.elementGroups.some(group => !group.elementNames.includes(elem.tagName))
      )
    );

    const otherElementsGroup = {
      title: 'other',
      elements: unusedElements
    } as ToolbarElementGroup;

    return this.editorContext.config.elementGroups
      .map(g => {
        return {
          title: g.title,
          elements: XmlRuleElement.Sorted(g.elementNames.map(elementName => this.editorContext.config.rules.ruleElements.get(elementName)).filter(e => e !== undefined))
        } as ToolbarElementGroup;
      })
      .concat(otherElementsGroup)
      .filter(g => g.elements.length !== 0);
  }
}

export interface ToolbarElementGroup {
  title: string;
  elements: XmlRuleElement[];
}
